module.exports = __webpack_public_path__ + "static/item--blinds--f4@3x.b5487400.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/item--blinds--f4@3x.png
// module id = 631
// module chunks = 126511778744290